import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as previewModalPictureActions from 'Global/Stores/previewModalPicture'
import * as rugsAsyncActions from 'Global/Stores/rugs'
import * as selectors from './selectors'
import { getRug } from 'Global/Stores/rugDetail'
import { reservationEditModalShow } from 'Global/Stores/modals'
import { userPermissions } from 'Components/Permissions/selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    currentIndex: selectors.previewModalIndex(state),
    currentPicture: selectors.currentPicture(state),
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    nextPicture: selectors.nextPicture(state),
    pictureError: selectors.pictureError(state),
    picturePending: selectors.picturePending(state),
    pictures: selectors.pictures(state),
    previewExpanded: selectors.previewExpanded(state),
    previewOpen: selectors.previewOpen(state),
    previousPicture: selectors.previousPicture(state),
    rug: selectors.detailRug(state),
    user: selectors.user(state),
    userPermissions: userPermissions(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getRug: rugId => dispatch(getRug(rugId)),
    setCurrentIndex: index => dispatch(previewModalPictureActions.previewModalIndexSet(index)),
    setPrimary: pictureId => dispatch(rugsAsyncActions.picturePrimarySet(pictureId)),
    showEditReservationModal: reservation => dispatch(reservationEditModalShow(reservation)),
    togglePreview: () => dispatch(previewModalPictureActions.makePreviewModalToggle()),
    togglePreviewExpansion: () => dispatch(previewModalPictureActions.previewModalExpansionToggle()),
    uploadDesignerPicture: (data, picture) => dispatch(rugsAsyncActions.pictureDesignerUpload(data, picture)),
  })

  Enhancer.displayName = 'RugDetailModuleEnhancer'

  Enhancer.propTypes = {
    currentIndex: PropTypes.number.isRequired,
    currentPicture: PropTypes.string.isRequired,
    getRug: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    nextPicture: PropTypes.bool.isRequired,
    pictureError: PropTypes.number.isRequired,
    picturePending: PropTypes.number.isRequired,
    previewExpanded: PropTypes.bool.isRequired,
    previewOpen: PropTypes.bool.isRequired,
    previousPicture: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired,
    rug: PropTypes.object.isRequired,
    setCurrentIndex: PropTypes.func.isRequired,
    setPrimary: PropTypes.func.isRequired,
    showEditReservationModal: PropTypes.func.isRequired,
    togglePreview: PropTypes.func.isRequired,
    togglePreviewExpansion: PropTypes.func.isRequired,
    uploadDesignerPicture: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    userPermissions: PropTypes.array.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
